(function () {
    'use strict';
    angular.module('GorillaBoy.OfficeEditor')
    .directive('officeFormSubmitter', [
            function () {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    scope.$on('submitForm', function(event, data, targetOrigin){
                        element.submit();
                        scope.$broadcast('postHostReady',null);
                    });
                },
            };
        }
    ]);
}());